

import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useState } from "react"

export const PreventiveWorkReportExport = (props) => {
    const { ExcelData, name, WardName, FromDate, ToDate } = props

    const totalCount = ExcelData && ExcelData.table && ExcelData.table.reduce((total, item) => {
        return total + +(item.totalPenalty)
    }, 0)


    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-ExportPreventiveWorkReport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black', }}
            />


            <table id="table-to-ExportPreventiveWorkReport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>


                <h4 style={{ textAlign: 'center', fontSize: 16 }}>Navi Mumbai Municipal Corporation</h4>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}>GARDEN DEPARTMENT</h5>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}>Project Name: GARDEN MAINTENANCE - {WardName.Label ? WardName.Label : '-'}</h5>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}> Garden Maintenance Preventive Works Total Amount:  Total Amount:- {totalCount && totalCount > 0 ? totalCount : '0'} Rs.</h5>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}>Report Name: GARDEN PREVENTIVE WORK</h5>
                <h5 style={{ textAlign: 'center', fontSize: 16 }}>From Date:- {FromDate ? FromDate : '-'}  To Date:- {ToDate ? ToDate : '-'} </h5>

                <tr><td></td></tr>

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>

                        <th style={{ textAlign: 'center' }}>Sr.No.</th>
                        <th>Sector</th>
                        <th>Asset Name</th>
                        <th>Upload Date</th>
                        <th>Work Name</th>
                        <th>Work Photo</th>
                        <th>Work Latitude</th>
                        <th>Work Longitude</th>
                        <th>Bench Mark</th>
                        <th>Defaulter</th>
                        <th>Unit-PerPenalty</th>
                        <th>Total-Penalty</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center" }}>
                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : i + 1}</td>
                                <td style={{ textAlign: "start" }}>{item.sectorname ? item.sectorname : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.assetName ? item.assetName : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.uploadDate ? item.uploadDate : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.workName ? item.workName : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.photo ? item.photo : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.afterLatitude ? item.afterLatitude : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.afterLongitude ? item.afterLongitude : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.benchMark ? item.benchMark : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.defualter ? item.defualter : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.perPenalty ? item.perPenalty : '-'}</td>
                                <td style={{ textAlign: "start" }}>{item.totalPenalty ? item.totalPenalty : '-'}</td>
                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}